/**
 * Phase 6e2c-3 — staging models for the accessory selector (§33.8).
 *
 * Legacy initialize: `staging_model` + `staging_position_model` = Backbone
 * clones of the accessory + position models, plus `init` / `init_position`
 * snapshots for the Select diff. Nothing persists until Select; the
 * with_position round-trip writes both staging models back silently.
 *
 * In React these are plain mutable objects held in refs by the selector
 * component; this module provides the tiny Backbone-compatible surface
 * (get/set/toJSON/hasChanged) the legacy code relied on, so the ported
 * methods read 1:1. No URL, no auto-save — pure client state.
 */

export class StagingModel {
  private attrs: Record<string, unknown>;
  private prev: Record<string, unknown> = {};

  constructor(initial: Record<string, unknown> = {}) {
    this.attrs = { ...initial };
  }

  get<T = unknown>(key: string): T {
    return this.attrs[key] as T;
  }

  /** Backbone set: records previous values so hasChanged works. */
  set(attrs: Record<string, unknown>): void {
    this.prev = {};
    Object.keys(attrs).forEach((k) => {
      this.prev[k] = this.attrs[k];
    });
    Object.assign(this.attrs, attrs);
  }

  /** legacy hasChanged(name) — did `name` change in the last set()? */
  hasChanged(name: string): boolean {
    if (!(name in this.prev)) return false;
    return this.prev[name] !== this.attrs[name];
  }

  toJSON(): Record<string, unknown> {
    return { ...this.attrs };
  }

  /** replace all attrs (response write-back). */
  replace(attrs: Record<string, unknown>): void {
    this.attrs = { ...this.attrs, ...attrs };
  }
}
